import { TruendoConsentData } from "./TruendoCookieConsentInterfaces";

/**
 * The consent initially set before the user makes any adjustments.
 */
export const initialConsentData: TruendoConsentData = {
  necessary: false,
  statistics: false,
  preferences: false,
  marketing: false,
  services: {
    truendo_privacy_mgmt: true,
    google_analytics: false,
    posthog: false,
    brevo: false,
  },
};
